module.exports = __webpack_public_path__ + "img/banner.8866dfa.png";